const ONESIGNAL_APP_ID = String(process.env.REACT_APP_ONESIGNAL_APP_ID || '').trim();
const ONESIGNAL_SDK_URL = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js';

let sdkLoadPromise = null;

const ensureOneSignalScript = () => {
  if (typeof window === 'undefined') return Promise.resolve(false);
  if (window.OneSignal) return Promise.resolve(true);
  if (sdkLoadPromise) return sdkLoadPromise;

  sdkLoadPromise = new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${ONESIGNAL_SDK_URL}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(true), { once: true });
      existing.addEventListener('error', () => resolve(false), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = ONESIGNAL_SDK_URL;
    script.defer = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });

  return sdkLoadPromise;
};

const isSupportedMobile = () => {
  if (typeof window === 'undefined') return false;
  const ua = String(navigator?.userAgent || '').toLowerCase();
  return /android|iphone|ipad|ipod|mobile/.test(ua);
};

export const initAdminPush = async (externalId) => {
  if (!ONESIGNAL_APP_ID) return { ok: false, skipped: true, reason: 'missing_app_id' };

  const loaded = await ensureOneSignalScript();
  if (!loaded || typeof window === 'undefined') return { ok: false, skipped: true, reason: 'sdk_load_failed' };

  window.OneSignalDeferred = window.OneSignalDeferred || [];

  return new Promise((resolve) => {
    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        await OneSignal.init({
          appId: ONESIGNAL_APP_ID,
          notifyButton: { enable: false },
          allowLocalhostAsSecureOrigin: true,
        });

        if (externalId) {
          await OneSignal.login(String(externalId));
        }

        // Mobile-first prompt for admin app/webview browser surface.
        if (isSupportedMobile()) {
          const perm = await OneSignal.Notifications.permission;
          if (perm !== true) {
            await OneSignal.Notifications.requestPermission();
          }
        }

        resolve({ ok: true });
      } catch (error) {
        resolve({ ok: false, error: error?.message || 'init_failed' });
      }
    });
  });
};

export const clearAdminPushSession = async () => {
  if (typeof window === 'undefined') return;
  if (!window.OneSignal) return;

  try {
    await window.OneSignal.logout();
  } catch (_err) {
    // no-op
  }
};
